/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from "antd"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateTimeFormatSimple } from "../../../models/datetime"
import { getHistoryDataFn } from "../../PharmacyRetail/PharmacyRetailSlice"
import { getDoctorsInDepartment, selectDoctors } from "../../registration/register/registerSlice"
import { getIdentityName, identity, identitys } from "../../../models/ToothHome"
import { getSFDoctorListAsync } from "../../sales/DoctorAccont/doctorAuditSlice"
interface InformationModalProps {
  visible: boolean
  type: number
  data: any
  onCancel: () => void
  onOk: (data: any) => void
}

export const InfoRegisterModal = ({
  visible,
  type,
  data,
  onCancel,
  onOk,
}: InformationModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { Option } = Select

  const [btnLoading, setBtnLoading] = useState(false)

  const [doctors, setDoctors] = useState<any>([])

  const [initialized, setInitialized] = useState(false)

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: "身份证格式错误",
    },
    {
      max: 18,
      message: "最长18位!",
    },
    {
      required: true,
    },
  ])

  const getIdCardInfo = (idCard: string) => {
    // 身份证上的年月日
    if (idCard) {
      // 先判断是不是中国大陆身份证
      if (
        (idCard.length !== 15 &&
          idCard.length !== 16 &&
          idCard.length !== 18) ||
        isNaN(Number(idCard.substr(0, 6)))
      ) {
        setIdCardRules([
          {
            max: 18,
            message: "最长18位!",
          },
          {
            required: true,
          },
        ])
      } else {
        setIdCardRules([
          {
            pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证格式错误",
          },
          {
            max: 18,
            message: "最长18位!",
          },
          {
            required: true,
          },
        ])
      }
    }
  }

  useEffect(() => {
    dispatch(getSFDoctorListAsync())
      .then(unwrapResult)
      .then((doctors) => setDoctors(doctors))
  }, [])

  useEffect(() => {
    if (visible && !initialized) {
      setInitialized(true)
      if (data?.patientRegistrationAgent?.id > 0 && type == 1) {
        form.setFieldsValue({
          ...data?.patientRegistrationAgent,
        })
      }
      if (data?.patientRegistrationBigAmount?.id > 0 && type == 2) {
        form.setFieldsValue({
          ...data?.patientRegistrationBigAmount,
        })
      }
    } else {
      form.resetFields()
      setInitialized(false)
    }
  }, [data, visible])

  return (
    <Modal
      visible={visible}
      title={type == 1 ? "代办信息登记 " : "大额信息登记"}
      width={1000}
      cancelText="取消"
      okText="确定"
      maskClosable={false}
      confirmLoading={btnLoading}
      onCancel={async () => {
        await form.resetFields()
        onCancel()
      }}
      onOk={form.submit}
    >
      <Row
        style={{
          backgroundColor: "rgba(243,248,255,1)",
          padding: "14px 20px",
          marginBottom: 30,
        }}
      >
        <Col span={24}>
          <Row>
            <Col span={8}>购买时间：{data?.createTime}</Col>
            <Col span={8}>患者姓名：{data?.patientName}</Col>
            <Col span={8}>身份证号：{data?.renyuanzjbh}</Col>
          </Row>
        </Col>
        <Col span={24} style={{ paddingTop: 6 }}>
          <Row>
            <Col span={8}>医保卡号：{data?.medicalCardNo}</Col>
            <Col span={8}>结算金额：{data?.totalPayAmount}</Col>
          </Row>
        </Col>
      </Row>
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        autoComplete="off"
        initialValues={{
          happendTime: moment(),
        }}
        onFinish={(values) => {
            onOk({
            ...values,
            patientId: data?.patientId,
            patientName: data?.patientName,
            patientIdCardNumber: data?.renyuanzjbh,
            medicalCard: data?.medicalCardNo,
            paymentId: data?.paymentId,
            paymentAmount: type == 2 ? data?.totalPayAmount : undefined,
          })
        }}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              label="患者联系电话"
              name="patientPhone"
              rules={[
                {
                  required: true,
                  pattern: new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/),
                  message: "请输入正确的手机号码",
                },
              ]}
            >
              <Input allowClear placeholder="请输入" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="审核药师"
              name="auditorName"
              rules={[
                {
                  max: 40,
                },
                {
                  required: true,
                  message: "请选择审核药师",
                },
              ]}
            >
              <Select
                placeholder="请选择"
                showSearch
                allowClear
                // onChange={(id: string) => {

                // }}
                filterOption={(input, option) => {
                  return option?.className
                    ? ((option?.className as unknown) as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    : false
                }}
              >
                {doctors.map((d: any) => (
                  <Select.Option
                    className={d.mnemonicCode}
                    key={d.id}
                    value={d.realname}
                  >
                    {d.realname}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {type == 1 && (
          <>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="代办人姓名"
                  name="agentName"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="代办人与患者关系" name="agentRelationship" rules={[{ required: true }]}>
                  <Select placeholder="请选择" allowClear>
                    {identitys?.filter(m => m != identity.BR ).map((v: any) => {
                      return (
                        <Select.Option key={v} value={getIdentityName(v)}>
                          {getIdentityName(v)}
                        </Select.Option>
                      )
                    })}{" "}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="代办人联系电话"
                  name="agentPhone"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/),
                      message: "请输入正确的手机号码",
                    },
                  ]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="代办人身份证号"
                  name="agentIdCard"
                  rules={idCardRules}
                >
                  <Input
                    allowClear
                    placeholder="请输入"
                    onChange={(e: any) => {
                      getIdCardInfo(e.target.value)
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  )
}
